import type { CSSProperties } from 'react';

/** 管理员后台页面统一容器与卡片风格（素质项等模块复用） */
export const adminPageWrap: CSSProperties = {
  margin: -24,
  padding: 24,
  minHeight: 'calc(100vh - 64px)',
  background: 'linear-gradient(180deg, #f5f0ff 0%, #f8f7fc 38%, #ffffff 100%)',
};

export const adminAlertStyle: CSSProperties = {
  marginBottom: 20,
  borderRadius: 12,
  border: '1px solid rgba(114, 46, 209, 0.18)',
  background: 'linear-gradient(135deg, rgba(239, 246, 255, 0.95) 0%, rgba(245, 240, 255, 0.98) 100%)',
};

export const adminFilterCardStyle: CSSProperties = {
  marginBottom: 16,
  borderRadius: 12,
  border: '1px solid rgba(0, 0, 0, 0.06)',
  boxShadow: '0 4px 20px rgba(15, 23, 42, 0.06)',
};

export const adminContentCardStyle: CSSProperties = {
  borderRadius: 12,
  border: '1px solid rgba(0, 0, 0, 0.06)',
  boxShadow: '0 4px 20px rgba(15, 23, 42, 0.05)',
};
